// extracted by mini-css-extract-plugin
module.exports = {"homePageWrapper":"d","split":"e","functionOfTheDayContainer":"f"};